export const CRA_REVIEW_SORTED_BY = { id: 'subjectId', desc: false };
export const CRA_REVIEW_PAGE = 0;
export const CRA_REVIEW_PAGE_SIZE = 25;
export const CRA_REVIEW_SUBJECT_ID = '';
